import { render, staticRenderFns } from "./DynamicPivotTable.vue?vue&type=template&id=1ba70a8b&scoped=true"
import script from "./DynamicPivotTable.vue?vue&type=script&lang=js"
export * from "./DynamicPivotTable.vue?vue&type=script&lang=js"
import style0 from "./DynamicPivotTable.vue?vue&type=style&index=0&id=1ba70a8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba70a8b",
  null
  
)

export default component.exports